module.exports = __webpack_public_path__ + "img/anbar.b0fab317.jpg";